var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
         _vm.btnClass,
         (this.type === 'primary') ? _vm.btnPrimClass : '',
         (this.type === 'secondary') ? _vm.btnSecndClass : '',
         this.disabled ? _vm.btnDisabled : ''
         ],attrs:{"type":"button"},on:{"click":function($event){return _vm.goTo()}}},[(this.type === 'secondary')?_c('i',{staticClass:"far fa-chevron-left nav-arrow right"}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.label)+"\n      "),(this.type === 'primary')?_c('i',{staticClass:"far fa-chevron-right nav-arrow left"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }